<iframe
  class="h-full w-full border-0"
  style="-webkit-filter: grayscale(50%)"
  [class.rounded-t-3]="rounded === 'top'"
  [class.rounded-3]="rounded === 'full'"
  [class.hidden]="!showMap"
  [src]="url | safe"
></iframe>
@if (defaultLocationLabel) {
  <cft-chip
    class="absolute top-0 right-0 p-sm"
    colour="gold"
    [text]="defaultLocationLabel"
    size="sm"
    [elevated]="true"
  ></cft-chip>
}
